export default __webpack_public_path__ + "static/media/myGirl.44ce8436.png";